export default "__VITE_ASSET__BPmASQEm__"